import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '科学知识', path: '/category/kexue-zhishi' },
    { label: '心理准备', path: '/category/xinli-zhunbei' },
    { label: '安全防护', path: '/category/anquan-fanghu' },
    { label: '常见误区', path: '/category/changjian-wuqu' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
  ],
  法律声明: [
    { label: '隐私政策', path: '/about' },
    { label: '免责声明', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-heart-pulse-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">
                青春性教育
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于为青少年提供科学、全面、温暖的性教育知识，帮助每一位年轻人在人生重要时刻做出明智的选择。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 青春性教育 版权所有
          </p>
          <p className="text-sm text-background-500">
            本站内容仅供参考，不能替代专业医疗建议
          </p>
        </div>
      </div>
    </footer>
  );
}